export enum ModalType {
  ConfirmModal = 'confirmModal',
  ContinueCancelModal = 'continueCancelModal',
  CustomModal = 'customModal',
  InputModal = 'inputModal',
  PreviewModal = 'previewModal',
  YesNoModal = 'yesNoModal'
}